import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import MenuSelector from '../../core/MenuSelector';
import SynchronisationDialog from '../../core/synchronisation/SynchronisationDialog';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../../core/utils/constants';
import ProjectOntologySearch from './ProjectOntologySearch';
import Errored from '../../core/Errored';
import GS from '../../grafsync/grafsync';
import { makeCancelable, sortObjects } from '../../core/utils/utils';
import Grid from '@material-ui/core/Grid';
import SyncIcon from '@material-ui/icons/Sync';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { Component, default as React } from 'react';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../../application-core/constants';
import AreYouSure from '../../core/AreYouSure';
import ActionText from '../../core/ActionText';
import CheckIfUsedAsAssociated from '../../core/CheckIfUsedAsAssociated';
import ComponentListItem from '../../core/ComponentListItem';
import OntologyIcon from '../../core/icons/Ontology';
import ComponentDialog from '../../core/project/ComponentDialog';
import { globalStyles as styles } from '../../core/style/gstheme';
import SecondaryButton from '../../core/SecondaryButton';
import LoadingButton from '../../core/LoadingButton';
import PrimaryButton from '../../core/PrimaryButton';

class OntologyProjectDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      componentId: null,
      link: null,
      isErrored: null,
      areYouSure: false,
      syncProject: false,
      searchLang: props.data.defaultLang,
      syncItems: [],
      integrations: [],
      deletions: 0,
      option: "",
      pendingDeletions: 0,
      componentChanges: [],
      isLoadingIntegrations: false
    };
    this.cancellable = null;
    this.cancellable1 = null;
    this.cancellable2 = null;
  }

  checkIfSure = (componentId, link) => (ev) => {
    this.setState({ areYouSure: true, componentId, link });
    ev.preventDefault();
    ev.stopPropagation();
  };

  onFull = () => {
    this.setState({ areYouSure: false });
    GS.operate("fullontologydeletion", this.props.graph, {
      resource: this.state.componentId
    });
  };

  onChangeSearchLang = (lang) => this.setState({ searchLang: lang });

  onNotSure = () => this.setState({ areYouSure: false });

  syncProject = async () => {
    this.setState({ isLoadingIntegrations: true }, async () => {
      try {
        GS.handle("sync-project");
        const integrations = await this.doGetIntegrations().promise;
        if (this.cancellable && this.cancellable.isCancelled()) return;
        const sortedIntegrations = sortObjects(integrations, "label", "en");
        const { ontologies } = this.props;
        const ontologyList = ontologies ? ontologies.map(ontology => ontology.id) : [];
        this.setState({
          integrations: sortedIntegrations,
          isLoadingIntegrations: false,
          syncProject: true,
          syncItems: [...ontologyList]
        });
      }
      catch (e) {
        if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) {
          this.setState({ isErrored: e, isLoadingIntegrations: false });
        }
      }
    });
  };

  doGetIntegrations() {
    this.cancellable = makeCancelable(GS.integrations());
    return this.cancellable;
  }

  syncItem = (ev, id) => {
    ev.preventDefault();
    ev.stopPropagation();
    let newSyncItems = [...this.state.syncItems];
    if (newSyncItems.includes(id)) {
      newSyncItems.splice(newSyncItems.indexOf(id), 1);
    }
    else {
      newSyncItems.push(id);
    }
    this.setState({ syncItems: newSyncItems });
  };

  cancelSyncProject = () => this.setState({
    syncProject: false,
    option: "",
    componentChanges: [],
    pendingDeletions: 0,
    deletions: 0
  });

  handleIntegrationChange = async (option) => {
    this.setState({ option, loadingChanges: true }, async () => {
      try {
        const changes = await this.doSynchroniseChanges(option).promise;
        if (this.cancellable1 && this.cancellable1.isCancelled()) return;
        const deletions = await this.doSynchroniseDeletions(option).promise;
        if (this.cancellable1 && this.cancellable1.isCancelled()) return;
        this.setState({
          componentChanges: changes,
          loadingChanges: false,
          mostRecentTime: deletions.mostRecentTime,
          deletions: deletions.resourceCount,
          pendingDeletions: deletions.pendingResourceCount
        });
      }
      catch (e) {
        if (!this.cancellable1 || (this.cancellable1 && !this.cancellable1.isCancelled())) {
          this.setState({ isErrored: e, syncProject: false, option: "", loadingChanges: false });
        }
      }
    });
  };

  doSynchroniseChanges(integration) {
    this.cancellable1 = makeCancelable(GS.synchroniseChanges(integration, this.props.graph));
    return this.cancellable1;
  }

  doSynchroniseDeletions(integration) {
    this.cancellable1 = makeCancelable(GS.synchroniseDeletions(integration, this.props.graph));
    return this.cancellable1;
  }

  clearError = () => this.setState({ isErrored: false });

  clearSyncItems = () => this.setState({ syncItems: [] });

  synchronise = async () => {
    this.setState({ processing: true, processingComplete: false }, async () => {
      this.doSynchronise()
        .promise
        .then(() => {
          this.setState({
            processing: false,
            processingComplete: true,
            syncProject: false,
            deletions: 0,
            componentChanges: [],
            pendingDeletions: 0,
            option: ""
          });
        })
        .catch((e) => {
          if (this.cancellable2 && !this.cancellable2.isCancelled()) this.setState({
            processing: false,
            isErrored: e,
            option: "",
            syncProject: false,
            componentChanges: [],
            pendingDeletions: 0,
            deletions: 0
          });
        });
    });
  };

  doSynchronise() {
    this.cancellable2 = makeCancelable(GS.synchronise(this.state.option, this.props.graph, this.state.syncItems));
    return this.cancellable2;
  }

  completeProcessing = () => this.setState({
    syncProject: false,
    processingComplete: false
  });

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
    if (this.cancellable1) this.cancellable1.cancel();
    if (this.cancellable2) this.cancellable2.cancel();
  }

  render() {

    const { componentChanges, option, processing, areYouSure, searchLang, mostRecentTime,
      syncProject, syncItems, integrations, isErrored, processingComplete, deletions, pendingDeletions, loadingChanges } = this.state;
    const { classes, project, ontologies, addComponent, graph, entitlements } = this.props;
    const defaultLang = this.props.data.defaultLang;

    const integrationList = integrations.map(integration => ({
      value: integration.id,
      label: integration.label["en"]
    }));

    if (isErrored) return <Errored dataTest="op-error" data={isErrored} clearError={this.clearError} />;
    if (processing || processingComplete) return <SynchronisationDialog processing={processing} onExit={this.completeProcessing} />;

    return (
      <div>
        <CheckIfUsedAsAssociated id={project} />
        <Grid container>
          <Grid item xs={12} className={classes.componentContainer} style={{ paddingBottom: 0 }}>
            {syncProject ?
              <Grid container spacing={0}>
                <Grid item xs={3}>
                  <div style={{ marginBottom: 6 }}>
                    <MenuSelector
                      autoFocus
                      hintWord="Select an integration"
                      hintPrefix={false}
                      dataTest="integration-type"
                      handleChange={this.handleIntegrationChange}
                      options={integrationList} />
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <span style={{ paddingLeft: 24 }}>
                    <SecondaryButton dataTest="cancel-sync-project" onClick={this.cancelSyncProject}>Cancel</SecondaryButton>
                  </span>
                  <span>
                    {(ontologies && ontologies.length > 0) &&
                      <span style={{ paddingLeft: 24 }}>
                        <SecondaryButton dataTest="clear" onClick={this.clearSyncItems}>Deselect All</SecondaryButton>
                      </span>
                    }
                  </span>
                  {option &&
                    <span style={{ paddingLeft: 24 }}>
                      {processing ?
                        <LoadingButton disabled />
                        :
                        <PrimaryButton dataTest="sync" onClick={this.synchronise}>Synchronise</PrimaryButton>
                      }
                    </span>
                  }
                </Grid>
                {syncProject && option && !mostRecentTime && <Typography data-test="not-run" variant="body2">This integration has not been run on this project.</Typography>}
                {syncProject && option && mostRecentTime && <Typography data-test="last-run" variant="body2">This integration wast last run at {(new Date(mostRecentTime)).toLocaleString()}.</Typography>}
                {syncProject && option && <Grid item xs={12}>
                  {loadingChanges ?
                    <Typography paragraph variant="body2">Gathering information...</Typography>
                    :
                    <React.Fragment>
                      <Typography data-test="deletions-since-last" style={{ color: '#ff6600' }} variant="body2">{deletions} deletion(s) since last run.</Typography>
                      <Typography paragraph variant="caption">Deletions are included in synchronisations.</Typography>
                      {pendingDeletions > 0 &&
                        <div>
                          <Typography data-test="pending-since-last" style={{ color: '#ff6600' }} variant="body2">{pendingDeletions} resource(s) pending deletion.</Typography>
                          <Typography paragraph variant="caption">Note that pending deleted resources are not included in synchronisations. After a period of time pending deletions are made permanent and will then appear in the deletions count.</Typography>
                        </div>
                      }
                    </React.Fragment>
                  }
                </Grid>
                }
              </Grid>
              :
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flex: 0 }}>
                      <ProjectLanguageSelector margin='12px' selectedLang={defaultLang} includeLabel={false} onSelect={this.onChangeSearchLang} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <ProjectOntologySearch key={searchLang} defaultLang={searchLang} project={project} graph={graph} />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'right' }}>
                  {entitlements.includes(APPENTITLEMENTS.SYNCHRONISE_DATA) &&
                    <Tooltip title="Synchronise project">
                      <IconButton data-test="sync-project" size="small" onClick={this.syncProject}>
                        <SyncIcon />
                      </IconButton>
                    </Tooltip>
                  }
                </Grid>
              </Grid>
            }
          </Grid>
          <Grid item xs={12} md={6} className={classes.componentContainer}>
            <div className={classes.componentContainerContent}>
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography variant="h6" className={classes.mainHeading}>Ontologies</Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'right' }}>
                  {!syncProject && entitlements && entitlements.includes(ENTITLEMENTS.CREATE_ONTOLOGY) &&
                    <ComponentDialog
                      dataTest="add-ontology"
                      slashHash={true}
                      lang={defaultLang}
                      existingComponents={[].concat(ontologies)}
                      project={project}
                      onAddComponent={addComponent}
                      label="Add Ontology" />
                  }
                </Grid>
              </Grid>
              {ontologies ?
                <div data-test="ontology-components" className={classes.componentList}>
                  {ontologies.map((component) =>
                    <ComponentListItem
                      dataTest={component.id}
                      id={component.id}
                      graph={graph}
                      key={component.id}
                      changes={syncProject && !loadingChanges ? componentChanges.find(change => change.component === component.id) : null}
                      sync={syncProject}
                      selected={syncItems.includes(component.id)}
                      defaultLang={defaultLang}
                      onSelect={this.syncItem}
                      accessEntitlements={[ENTITLEMENTS.VIEW_ONTOLOGY]}
                      title={component.title}
                      entitlement={ENTITLEMENTS.CREATE_ONTOLOGY}
                      link={APPLICATION_PATHS.ONTOLOGY_MANAGER + "/project/ontology#project=" + project + "&ontology=" + component.id}
                      onDelete={this.checkIfSure(component.id, APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/detail#project=' + project)}
                      description={component.description}
                      avatar={<OntologyIcon style={{ width: 20, height: 20 }} />}
                    />
                  )}
                </div>
                :
                <ActionText offset="100px">Create or import an ontology to get started.</ActionText>
              }
            </div>
          </Grid>
        </Grid>
        {areYouSure && <AreYouSure onSure={this.onFull} onNotSure={this.onNotSure} message={[
          "Do you really want to delete this ontology?"
        ]} />}
      </div>
    );
  }
}

OntologyProjectDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  project: PropTypes.string.isRequired,
  onDeleteComponent: PropTypes.func.isRequired,
  addComponent: PropTypes.func.isRequired,
  ontologies: PropTypes.array,
  entitlements: PropTypes.array,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(OntologyProjectDetail);